{#if type === 'blockquote'}
  <blockquote>
    <slot></slot>
  </blockquote>
{:elseif type === 'blockquote_owner'}
  <div class='blockquote-owner'>
    <slot></slot>
  </div>
{/if}

<style>
  blockquote {
    position: relative;
    border: solid #d8d8d8;
    border-width: 1px 0 1px;
    display: flex;
    flex-direction: column;
    align-items: baseline;
    width: 100%;
    padding: 2rem 0;
    margin: 2rem 0;
    @media(min-width: 992px) {
      padding: 3.75rem 0;
      margin: 3.75rem 0;
    }
    &:before {
      position: absolute;
      top: 2.4rem;
      left: 0;
      content: '';
      width: 37px;
      height: 32px;
      background-repeat: no-repeat;
      background-size: contain;
      background-image: url('/img/icons/quote.svg');
      @media(min-width: 767px) {
        top: 2.5rem;
      }
      @media(min-width: 992px) {
        top: 4rem;
      }
    }
    :global(p) {
      font-style: italic;
      margin-left: 4rem;
      margin-top: 0;
      position: relative;
      font-weight: 500;
      font-size: 1.125rem;
      line-height: 1.56;
      color: #0e1522;
      quotes: "«" "»" "«" "»";
      @media(min-width: 767px) {
        font-size: 1.125rem;
        max-width: 72%;
        margin-left: 10%;
      }
      @media(min-width: 992px) {
        font-size: 1.5rem;
        font-weight: 500;
      }
      &:first-of-type::before {
        content: open-quote" ";
        margin-right: -4px;
        top: 0;
        left: 0;
        font-weight: 500;
        font-size: 1.2rem;
        @media(min-width: 767px) {
          top: -4px;
          left: -1.4rem;
          font-size: 1.4rem;
        }
        @media(min-width: 992px) {
          position: absolute;
          left: -1.4rem;
          font-size: 1.8rem;
        }
      }
      &:last-of-type {
        margin-bottom: 0px;
        &:after {
          content: close-quote;
          font-weight: 500;
          font-size: 1.2rem;
          margin-left: 2px;
          vertical-align: middle;
          @media(min-width: 767px) {
            font-size: 1.4rem;
          }
          @media(min-width: 992px) {
            font-size: 1.8rem;
          }
        }
      }
    }
  }

  .blockquote-owner {
    right: 0;
    opacity: 0.5;
    line-height: 1.5rem;
    font-family: "FormularRegular";
    font-size: 0.875rem;
    margin-left: 4rem;
    margin-top: 0.5rem;
    order: 6;
    @media(min-width: 767px) {
      top: 2rem;
      max-width: 14%;
      position: absolute;
    }
    @media(min-width: 992px) {
      top: 4rem;
    }
  }
</style>
